export enum FormMode {
    COPY = 'copy',
    EDIT = 'edit',
    ADD = 'add',
    REMOVE = 'remove',
    LIST = 'list',
}
